import type { Conversation } from "@lumen/shared";

export type ProjectView = "chat" | "editor";
const preferenceKey = (projectId: string) => `lumen:project-view:${projectId}`;

export function preferredProjectView(projectId: string): ProjectView {
  try {
    return localStorage.getItem(preferenceKey(projectId)) === "editor"
      ? "editor"
      : "chat";
  } catch {
    return "chat";
  }
}

export function rememberProjectView(projectId: string, view: ProjectView) {
  try {
    localStorage.setItem(preferenceKey(projectId), view);
  } catch {
    // View switching still works when browser storage is unavailable.
  }
}

export function projectConversationPath(
  conversation: Pick<Conversation, "id" | "groupId">,
  view?: ProjectView,
) {
  const editor =
    (view ??
      (conversation.groupId
        ? preferredProjectView(conversation.groupId)
        : "chat")) === "editor";
  return `/projects/c/${conversation.id}${editor ? "/workspace" : ""}`;
}

export function conversationViewPath(
  pathname: string,
  search: string,
  view: ProjectView,
) {
  const base = pathname.replace(/\/workspace\/?$/, "").replace(/\/$/, "");
  return `${base}${view === "editor" ? "/workspace" : ""}${search}`;
}

export function chatConversationPath(id: string, currentPath: string) {
  return conversationViewPath(
    `/c/${id}`,
    "",
    /\/workspace\/?$/.test(currentPath) ? "editor" : "chat",
  );
}
